// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"qempo_UploadBox_dropzone-2aFiaAh","active":"qempo_UploadBox_active-2W7U3OB","uploadInvoiceWrap":"qempo_UploadBox_uploadInvoiceWrap-1f3gd47","error":"qempo_UploadBox_error-2qSwiPI","invoiceWrap":"qempo_UploadBox_invoiceWrap-2AJHnbI","leftWrap":"qempo_UploadBox_leftWrap-1I-XxD4","text":"qempo_UploadBox_text-VmjcNoN","right":"qempo_UploadBox_right-2HAd8z3","leftIconWrap":"qempo_UploadBox_leftIconWrap-FKqsNx4","middleWrap":"qempo_UploadBox_middleWrap--rDnAwP","upload":"qempo_UploadBox_upload-3IowMD_","buttonLabel":"qempo_UploadBox_buttonLabel-1-hNo58"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Sale/components/UploadBox/UploadBox.scss
// module id = 1828
// module chunks = 0